var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "help-24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1315.000000, -683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help-24px",
    transform: "translate(1313.000000, 681.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 30 0 30 30 0 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,2.5 C8.1,2.5 2.5,8.1 2.5,15 C2.5,21.9 8.1,27.5 15,27.5 C21.9,27.5 27.5,21.9 27.5,15 C27.5,8.1 21.9,2.5 15,2.5 Z M16.25,23.75 L13.75,23.75 L13.75,21.25 L16.25,21.25 L16.25,23.75 Z M18.8375,14.0625 L17.7125,15.2125 C16.8125,16.125 16.25,16.875 16.25,18.75 L13.75,18.75 L13.75,18.125 C13.75,16.75 14.3125,15.5 15.2125,14.5875 L16.7625,13.0125 C17.225,12.5625 17.5,11.9375 17.5,11.25 C17.5,9.875 16.375,8.75 15,8.75 C13.625,8.75 12.5,9.875 12.5,11.25 L10,11.25 C10,8.4875 12.2375,6.25 15,6.25 C17.7625,6.25 20,8.4875 20,11.25 C20,12.35 19.55,13.35 18.8375,14.0625 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.278ec8a6.svg";
export { ForwardRef as ReactComponent };